import * as Auth from '../contexts/AuthContext';
import { chatsOwner } from '../lib/chatsKeys';

/*
 * r16p review T1: the signed-in account as the chat caches key it (lib/chatsKeys.js). Reads the auth context without throwing outside
 * an AuthProvider (and in tests whose AuthContext mock has only useAuth): then the owner is 'signed-out'.
 */
const readAuth = typeof Auth.useOptionalAuth === 'function' ? Auth.useOptionalAuth : () => null;

export default function useChatsOwner() {
  const ctx = readAuth();
  return chatsOwner(ctx && ctx.user);
}
